<template>
  <BaseWorkPageLayout :title="$t('global.checks')" icon="money-check-alt">
    <template #before_scroll_container>
      <div
        v-if="checkDepositList"
        class="flex flex-row space-x-3 bg-white p-3 dark:bg-slate-700"
        role="none"
      >
        <RouterLink
          v-for="(type, index) in checkTypes"
          :key="index"
          v-slot="{ isExactActive }"
          :to="{ name: type.routeName }"
          class="relative flex flex-1"
        >
          <SelectCheckViewLink
            v-if="type"
            :key="type"
            :is-active="isExactActive"
            :type="type"
            :status="type.status"
          />
        </RouterLink>
      </div>
    </template>
    <RouterView />
  </BaseWorkPageLayout>
</template>

<script>
import { mapGetters } from 'vuex'
import SelectCheckViewLink from './SelectCheckViewLink'

export default {
  name: 'CheckPage',
  components: {
    SelectCheckViewLink
  },
  data() {
    return {
      check_type: this.selectedCheckType
    }
  },
  computed: {
    ...mapGetters({
      checkDepositList: 'invoicing/getCheckDepositList',
      metadata: 'invoicing/getCheckMetadata'
    }),
    selectedCheckType() {
      return this.checkTypes[0]
    },
    checkTypes() {
      return [
        {
          id: 1,
          name: this.$t('global.checks_deposit'),
          count: `${this.$t('attributes.quantity')}: ${this.checkDepositQuantity}`,
          total: `${this.$t('attributes.total_amount')}: ${this.$h.formatCurrency(this.checkDepositTotalAmount)}`,
          routeName: 'check_index_route',
          status: 'checkdeposits'
        },
        {
          id: 2,
          name: this.$t('global.checks_to_be_deposited'),
          count: `${this.$t('attributes.quantity')}: ${this.checkQuantity('TBDEP')}`,
          total: `${this.$t('attributes.total_amount')}: ${this.$h.formatCurrency(this.checkTotalAmount('TBDEP'))}`,
          routeName: 'check_tbdep_index_route',
          status: 'TBDEP'
        },
        {
          id: 3,
          name: this.$t('global.checks_to_be_cashed'),
          count: `${this.$t('attributes.quantity')}: ${this.checkQuantity('CAS')}`,
          total: `${this.$t('attributes.total_amount')}: ${this.$h.formatCurrency(this.checkTotalAmount('CAS'))}`,
          routeName: 'check_dep_index_route',
          status: 'CAS'
        },
        {
          id: 4,
          name: this.$t('global.checks_refused'),
          count: `${this.$t('attributes.quantity')}: ${this.checkQuantity('REF')}`,
          total: `${this.$t('attributes.total_amount')}: ${this.$h.formatCurrency(this.checkTotalAmount('REF'))}`,
          routeName: 'check_ref_index_route',
          status: 'REF'
        }
      ]
    },
    checkDepositQuantity() {
      return this.checkDepositList.length
    },
    checkDepositTotalAmount() {
      return this.checkDepositList?.reduce(
        (a, b) => a + Number(b.total_amount),
        0
      )
    }
  },
  methods: {
    checkQuantity(status) {
      return this.metadata?.checks_list?.filter(
        (check) => check.check_status === status
      ).length
    },
    checkTotalAmount(status) {
      let list = this.metadata?.checks_list?.filter(
        (check) => check.check_status === status
      )
      let temp = []
      list?.map((check) => temp.push(Number(check.amount)))
      if (temp.length > 0) {
        return temp.reduce(
          (previousVal, currentVal) => previousVal + currentVal,
          0
        )
      }
      return 0
    }
  },
  watch: {
    '$route.name'(newValue) {
      switch (newValue) {
        case 'check_index_route':
          this.selectedCheckType = this.checkTypes.filter(
            (el) => el.id === 1
          )[0]
          break
        case 'check_tbdep_index_route':
          this.selectedCheckType = this.checkTypes.filter(
            (el) => el.id === 2
          )[0]
          break
        case 'check_dep_index_route':
          this.selectedCheckType = this.checkTypes.filter(
            (el) => el.id === 3
          )[0]
          break
        case 'check':
          this.$router.push({ name: 'check_index_route' })
          break
        case 'check_ref_index_route':
          this.selectedCheckType = this.checkTypes.filter(
            (el) => el.id === 4
          )[0]
          break
        case 'check_deposit_form_route':
          this.selectedCheckType = null
          break
      }
    }
    /* check_type(newValue) {
       if (newValue && newValue !== null) {
         switch (newValue.id) {
           case 1 :
             this.$router.push({name: 'check_index_route'})
             break
           case 2 :
             this.$router.push({name: 'check_tbdep_index_route'})
             break
           case 3 :
             this.$router.push({name: 'check_dep_index_route'})
             break
           case 4 :
             this.$router.push({name: 'check_ref_index_route'})
             break
         }
       }
     }*/
  },
  mounted() {}
}
</script>
<style scoped></style>
